import React from 'react';
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from '@mui/material';
import useFetchProjectCommits from '../../hooks/useFetchProjectCommits';

const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const getCommitColor = (commits) => {
  if (commits > 50) return '#1EEDC2';
  if (commits > 25) return '#16C4A0';
  if (commits > 15) return '#109C7F';
  if (commits > 5) return '#065B4A';
  if (commits > 0) return '#2C2C2C';
  return '#ffffff';
};

const HeatMapCommits = () => {
  const { commitData, loading, error } = useFetchProjectCommits();

  if (loading) return <p>Loading commit data...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <Box sx={{ width: '100%', margin: 'auto', mt: 2, padding: '10px' }}>
      <Grid container spacing={2}>
        <Grid item xs={8.4}>
          <Paper
            sx={{
              height: '100%',
              minHeight: '250px',
              boxShadow: '4px 4px 12px rgba(0,0,0,0.3)',
              borderRadius: '8px',
              padding: '20px',
            }}
          ></Paper>
        </Grid>

        {/* Right Side - Table + Legend */}
        <Grid item xs={3.6}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              boxShadow: '4px 4px 12px rgba(0,0,0,0.3)',
              padding: '12px',
            }}
          >
            {/* Heatmap Table */}
            <TableContainer component={Paper} sx={{ maxHeight: 300, overflow: 'auto', boxShadow: 3 }}>
              <h4>Weekly Project Commits by PM</h4>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        backgroundColor: '#222',
                        color: 'white',
                        fontWeight: 'bold',
                        minWidth: '80px',
                        maxWidth: '100px',
                        fontSize: '12px',
                        padding: '4px',
                      }}
                    >
                      Name
                    </TableCell>
                    {weekdays.map((day) => (
                      <TableCell
                        key={day}
                        sx={{
                          backgroundColor: '#222',
                          color: 'white',
                          fontWeight: 'bold',
                          width: '10px',
                          fontSize: '12px',
                          padding: '4px',
                        }}
                      >
                        {day}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {Object.entries(commitData).map(([pm, days]) => (
                    <TableRow key={pm}>
                      <TableCell sx={{ fontSize: '12px', width: '80px', padding: '4px' }}>{pm}</TableCell>
                      {weekdays.map((day) => (
                        <Tooltip key={day} title={`${days[day] || 0} commits`} arrow disableInteractive>
                          <TableCell
                            sx={{
                              width: '10px',
                              height: '10px',
                              minWidth: '10px',
                              minHeight: '10px',
                              padding: '2px',
                              borderRadius: '2px',
                              backgroundColor: getCommitColor(days[day] || 0),
                              textAlign: 'center',
                              cursor: 'pointer',
                              border: '1px solid rgba(0, 0, 0, 0.1)',
                              transition: 'transform 0.1s ease-in-out',
                              '&:hover': { transform: 'scale(1.1)' },
                            }}
                          ></TableCell>
                        </Tooltip>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mt: 2 }}>
              <Box sx={{ backgroundColor: '#ffffff', padding: '6px', border: '1px solid #ddd' }}>0</Box>
              <Box sx={{ backgroundColor: '#2C2C2C', padding: '6px', color: 'white' }}>1-5</Box>
              <Box sx={{ backgroundColor: '#065B4A', padding: '6px', color: 'white' }}>6-15</Box>
              <Box sx={{ backgroundColor: '#109C7F', padding: '6px', color: 'white' }}>16-25</Box>
              <Box sx={{ backgroundColor: '#16C4A0', padding: '6px', color: 'white' }}>26-50</Box>
              <Box sx={{ backgroundColor: '#1EEDC2', padding: '6px', color: 'black', fontWeight: 'bold' }}>50+</Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HeatMapCommits;
